import helperStyles from "@src/components/helpers.module.scss";
import React from "react";

export const Willcall: React.FC = () => {
	return (
		<div className={helperStyles.iconContainer}>
			<svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24">
				<path
					fill="none"
					stroke="#A09FA7"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth="1.5"
					d="M18.118 14.702L14 15.5c-2.782-1.396-4.5-3-5.5-5.5l.77-4.13L7.815 2H4.064c-1.128 0-2.016.932-1.847 2.047c.42 2.783 1.66 7.83 5.283 11.453c3.805 3.805 9.286 5.456 12.302 6.113c1.165.253 2.198-.655 2.198-1.848v-3.584z"
				/>
			</svg>
		</div>
	);
};
